module.exports = __webpack_public_path__ + "static/ambush_drake-7c567edaee5d21e4e9738dc5417089bb.png";